import { connect, MapDispatchToProps } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { startNewChatWithParticipant } from '@wix/da-shared-react/pkg/Chat/redux/actions';
import { Props } from './ChatButton';

type StateProps = never;
type DispatchProps = Pick<Props, 'startChat'>;
type OwnProps = Omit<Props, keyof (StateProps | DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  startChat: () =>
    dispatch(
      startNewChatWithParticipant(uniqueId('new-chat-request'), {
        id: ownProps.user.useridUuid,
        name: ownProps.user.username,
      })
    ),
});

export default connect(undefined, mapDispatchToProps);
